// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3yFuX","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3L-0C","obliqueLine":"membershipbadge_obliqueLine__gExjz"};